import React, { PureComponent, Fragment } from 'react'
import { arrayOf, shape, string, object, bool } from 'prop-types'
import { createComponent } from '@ycos/fela'
import { Picture } from '@ycos/picture'
import { Caption } from '@ycos/primitives'
import { hasTag } from '@ycos/coremedia-renderer'
import LayoutWithMargins from '@ycos/layout-with-margins'

const ImageContainer = createComponent(
  'ImageContainer',
  (props) => {
    const { theme, isFullBleed } = props

    if (isFullBleed) {
      const imageWidthWithoutMargins = theme.breakpoints.xlarge.width - 2 * theme.breakpoints.xlarge.marginOuter

      return {
        position: 'relative',
        margin: 0,
        padding: 0,
        width: '100vw',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw',
        'screen-xlarge': {
          width: `${imageWidthWithoutMargins}px`,
          /**
           * We push the container to the middle of the page with left: 50% and pull it to the left corner with marginleft: -50vw
           * After that we calculate the value of the margins with (100vw - imageWidthWithoutMargins) and divide it by 2 to have equal margins on the right side and left
           */
          left: `calc(50% + ((100vw - ${imageWidthWithoutMargins}px)/2))`
        }
      }
    }
  },
  'div'
)

class Image extends PureComponent {
  static layoutVariant = 'isc-image'

  render() {
    const { item, config, lazy } = this.props
    const { subTitlePlain, pictures, tags } = item

    const isFullBleed = hasTag(tags, 'Image.FullBleed')

    return (
      <Fragment>
        <ImageContainer isFullBleed={isFullBleed}>
          <Picture images={pictures} imagesphere={config.imageSphere} lazy={lazy} />
          {isFullBleed && subTitlePlain && (
            <LayoutWithMargins>
              <PictureCaption>{subTitlePlain}</PictureCaption>
            </LayoutWithMargins>
          )}
          {!isFullBleed && subTitlePlain && <PictureCaption>{subTitlePlain}</PictureCaption>}
        </ImageContainer>
      </Fragment>
    )
  }
}

Image.propTypes = {
  item: shape({
    subTitlePlain: string,
    pictures: arrayOf(
      shape({
        imageUrl: string.isRequired
      })
    ).isRequired
  }).isRequired,
  config: object,
  lazy: bool
}

Image.defaultProps = {
  config: {},
  lazy: true
}

const PictureCaption = createComponent(
  'PictureCaption',
  ({ theme }) => ({
    marginTop: `${theme.spacingMultiplier}px`
  }),
  Caption
)

export default Image
